export default __webpack_public_path__ + "static/tb_helles_03-44c10d7e3a7a5b52cb81488a48468338.svg";